import PubSub from "pubsub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var CommunityEngagementResultsBarGraphs = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CommunityEngagementResultsBarGraphs',
	};

	$.extend(true, this.options, options);

};

CommunityEngagementResultsBarGraphs.prototype.init = function() {

	var self = this;

	ScrollTrigger.create({
		trigger: self.options.$el.find(`.${self.options.baseClass}__componentWrapper`),
		start: '300 bottom',
		once: true,
		// markers: true,
		onEnter: ({progress, direction, isActive}) => {
			self.animateBarGraphsIn();
		}
	});

};

CommunityEngagementResultsBarGraphs.prototype.animateBarGraphsIn = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__resultBarGraph`).each(function() {

		var $emptySpace = $(this).find(`.${self.options.baseClass}__resultBarGraph__emptySpace`);
		var $percent = $(this).find(`.${self.options.baseClass}__percent__number`);
		var percentValue = $(this).data('percent');
		var newLeft = percentValue + '%';

		gsap.timeline({

		})
		.to($emptySpace, {
			duration: 1.6,
			ease: "power1.out",
			left: newLeft
		}, "0" )
		.to($percent, {
			textContent: percentValue,
			duration: 1.6,
			ease: "power1.out",
			snap: { textContent: 1 },
		}, "0" )
		;

	});

};

export default CommunityEngagementResultsBarGraphs;
